import React from "react";
import { Download, ExternalLink, Smartphone, Sparkles } from "lucide-react";

const APK_URL =
  "https://customer-assets.emergentagent.com/job_femmes-secure/artifacts/8u4c5efx_application-aad16817-5a24-4310-b3d4-35fa7ac2bc9f.apk";
const WEB_PREVIEW_URL =
  "https://app.emergent.sh/share-preview?app=maman-kingdom";

export default function Application() {
  return (
    <section
      id="application"
      data-testid="application-section"
      className="relative bg-[#FAF7F2] py-24 lg:py-36 overflow-hidden"
    >
      <div className="max-w-[1400px] mx-auto px-6 grid lg:grid-cols-12 gap-14 items-center">
        {/* Visual block */}
        <div className="lg:col-span-5 relative">
          <div className="relative mx-auto w-[260px] md:w-[300px] aspect-[9/19] bg-[#4A192C] rounded-[2.5rem] p-3 shadow-[0_30px_80px_-30px_rgba(74,25,44,0.6)]">
            <div className="w-full h-full rounded-[2rem] bg-gradient-to-br from-[#F2EBE1] via-[#FAF7F2] to-[#C5A059]/30 relative overflow-hidden">
              <div className="absolute top-0 left-1/2 -translate-x-1/2 w-28 h-6 bg-[#4A192C] rounded-b-2xl" />
              <div className="pt-14 px-5 flex flex-col items-center text-center">
                <Sparkles className="w-10 h-10 text-[#C5A059]" />
                <div className="font-serif-display text-2xl text-[#4A192C] mt-6 leading-tight">
                  Maman
                  <br />
                  <em className="text-[#C5A059]">Kingdom</em>
                </div>
                <div className="mt-6 w-full space-y-2">
                  {["Rituels quotidiens", "Cercle des Reines", "Ressources & aide"].map(
                    (item) => (
                      <div
                        key={item}
                        className="bg-[#FAF7F2] border border-[#4A192C]/15 px-3 py-2 text-[0.72rem] text-[#4A192C] font-medium tracking-wide"
                      >
                        {item}
                      </div>
                    )
                  )}
                </div>
                <div className="mt-6 inline-flex items-center gap-1.5 text-[0.62rem] tracking-[0.22em] uppercase text-[#6B585F]">
                  <Smartphone className="w-3 h-3" /> Android · APK
                </div>
              </div>
            </div>
          </div>
          <div className="hidden lg:block absolute -top-6 -left-6 w-28 h-28 border border-[#C5A059]" />
          <div className="hidden lg:block absolute -bottom-8 -right-8 w-20 h-20 bg-[#C5A059]/20" />
        </div>

        {/* Copy + CTAs */}
        <div className="lg:col-span-7">
          <p className="sdm-divider">Application mobile</p>
          <h2 className="font-serif-display text-4xl lg:text-6xl text-[#4A192C] mt-8 leading-tight">
            Maman Kingdom,
            <br />
            <em className="text-[#C5A059]">le Sanctuaire en poche.</em>
          </h2>
          <p className="mt-6 text-[#2C1E23]/85 text-lg leading-relaxed max-w-2xl">
            Prolongez l&apos;expérience du Sanctuaire partout avec vous :
            rituels quotidiens, accès au cercle des Reines, ressources
            d&apos;urgence, méditations guidées. Disponible en téléchargement
            direct (APK Android) et en version web.
          </p>

          <div className="mt-10 flex flex-wrap items-center gap-4">
            <a
              href={APK_URL}
              data-testid="download-apk-button"
              download
              className="sdm-btn-primary"
            >
              <Download className="w-4 h-4" />
              Télécharger l&apos;APK
            </a>
            <a
              href={WEB_PREVIEW_URL}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="web-preview-button"
              className="sdm-btn-ghost"
            >
              <ExternalLink className="w-4 h-4" />
              Voir la version web
            </a>
          </div>

          {/* Install note */}
          <div
            data-testid="apk-install-note"
            className="mt-10 border-l-4 border-[#C5A059] bg-[#F2EBE1] p-5 max-w-2xl"
          >
            <div className="text-[0.68rem] tracking-[0.22em] uppercase text-[#C5A059] font-medium mb-1">
              Installation Android
            </div>
            <p className="text-sm text-[#2C1E23]/85 leading-relaxed">
              Après le téléchargement, ouvrez le fichier APK depuis votre
              téléphone. Il se peut que votre appareil demande l&apos;autorisation
              d&apos;installer des applications depuis des sources inconnues —
              c&apos;est normal pour les applications distribuées en dehors du
              Play Store.
            </p>
          </div>

          <div className="mt-8 grid sm:grid-cols-3 gap-6 max-w-2xl">
            {[
              { n: "100%", l: "gratuite" },
              { n: "FR", l: "en français" },
              { n: "🔒", l: "confidentielle" },
            ].map((s) => (
              <div key={s.l} className="border-t border-[#4A192C]/25 pt-4">
                <div className="font-serif-display text-2xl text-[#4A192C]">
                  {s.n}
                </div>
                <div className="text-[0.68rem] tracking-[0.2em] uppercase text-[#6B585F] mt-1">
                  {s.l}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
